import Bottombar from "@/components/bottombar"
import Button from "@/components/button"
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet"
import { createEmptyItem } from "@/packaging-v2/lib/form"
import useStore from "@/store"
import { PackagingV2Sheets } from "@/store/packaging-v2"

export interface AddItemSheetProps {
  open: boolean
  onOpenChange?: (open: boolean) => void
}

/**
 * Sheet for adding a new item to the current machine
 */
export default function AddItemSheet({ open, onOpenChange }: AddItemSheetProps) {
  const packagingV2Store = useStore.use.packagingV2()
  const { currDeptId, currMachineId } = packagingV2Store

  function handleAddItem() {
    // Get current form data
    const formData = packagingV2Store.getFormData(currDeptId, currMachineId)
    const nextSequenceOrder =
      formData?.items.length
        ? Math.max(...formData.items.map((item) => item.sequenceOrder)) + 1
        : 1

    // Create new empty item
    const newItem = createEmptyItem(nextSequenceOrder)

    // Add to store
    packagingV2Store.addItem(currDeptId, currMachineId, newItem)

    // Set as current item
    packagingV2Store.setCurrItemIndex(formData?.items.length || 0)

    // Close sheet
    packagingV2Store.setCurrSheet(PackagingV2Sheets.None)
    onOpenChange?.(false)
  }

  function handleClose() {
    packagingV2Store.setCurrSheet(PackagingV2Sheets.None)
    onOpenChange?.(false)
  }

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="rounded-t-xl">
        <SheetHeader>
          <SheetTitle>Add New Item</SheetTitle>
          <SheetDescription>
            Add a new item to this machine's sheet. You can select the product
            and SKU after adding.
          </SheetDescription>
        </SheetHeader>

        <Bottombar className="flex gap-4 bg-white">
          <Button variant="outline" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="flex-1" onClick={handleAddItem}>
            Add Item
          </Button>
        </Bottombar>
      </SheetContent>
    </Sheet>
  )
}
